module.exports = "/static/assets/c15700459e57153ea5c0c6929a9e57dd.png";